import { withGlobal } from "components/global/GlobalWrapper";
import { BuildingEditBuildingStructure } from "./BuildingEditBuildingStructure";
import { buildingStructuresReducers } from "components/stores/building_structures/reducers";

export default withGlobal(BuildingEditBuildingStructure, { reducers: buildingStructuresReducers });
